import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useServerText from "util/serverText";
import CommonNotificationSummary from "components/event-notifications/event-notification-types/CommonNotificationSummary";
import {
  useGetPriorities,
  useGetUsers,
  useGetTeams,
  useGetInvestigations
} from "security-app/hooks/useInvestigationsAPI";
import { usePagination } from "common/contexts";
function CreateInvestigationNotificationSummary({
  notification = {},
  ...restProps
}) {
  var _a, _b;
  const { t } = useTranslation("enterprise_security_investigations");
  const localPagination = usePagination();
  const { investigations } = useGetInvestigations(localPagination);
  const investigationsMap = useMemo(
    () => Object.fromEntries(investigations.map((investigation) => [investigation.id, { label: investigation.name }])),
    [investigations]
  );
  const { users } = useGetUsers(true);
  const { teams } = useGetTeams(true);
  const usersTeamsMap = useMemo(
    () => ({
      ...Object.fromEntries(users.map((user) => [user.id, { label: user.full_name, icon: "user" }])),
      ...Object.fromEntries(teams.map((team) => [team.id, { label: team.name, icon: "users" }]))
    }),
    [users, teams]
  );
  const { priorities } = useGetPriorities(true);
  const serverText = useServerText();
  const getPriorityText = useCallback(
    (value) => {
      var _a2;
      return value ? serverText((_a2 = priorities.find((priority) => priority.priority === value)) == null ? void 0 : _a2.text) : "";
    },
    [priorities, serverText]
  );
  return /* @__PURE__ */ React.createElement(CommonNotificationSummary, { ...restProps, notification }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, t("notification_fields.create_new_investigation")), /* @__PURE__ */ React.createElement("td", null, notification.config.create_new_investigation ? /* @__PURE__ */ React.createElement("em", null, t("notification_fields.true")) : /* @__PURE__ */ React.createElement("em", null, t("notification_fields.false")))), !notification.config.create_new_investigation && /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, t("notification_fields.investigation")), /* @__PURE__ */ React.createElement("td", null, (_a = investigationsMap[notification.config.investigation_id]) == null ? void 0 : _a.label)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, t("notification_fields.assign_to")), /* @__PURE__ */ React.createElement("td", null, (_b = usersTeamsMap[notification.config.investigation_assigned_to]) == null ? void 0 : _b.label)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, t("notification_fields.priority")), /* @__PURE__ */ React.createElement("td", null, getPriorityText(notification.config.investigation_priority))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, t("notification_fields.status")), /* @__PURE__ */ React.createElement("td", null, serverText(notification.config.investigation_status))));
}
export default CreateInvestigationNotificationSummary;
